import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue'

  import KetchUpButton from '@/components/common/KetchUpButton.vue'
  import LoadingSpinner from '@/components/common/LoadingSpinner.vue'

  import { useRoute } from 'vue-router/composables'
  import useCommonMixin from '@/composables/useCommonMixin'
  import useIcons from '@/composables/useIcons'
  import useAuthentication from '@/composables/useAuthentication'
  import useI18n from '@/composables/useI18n'

  import { UserModule } from '@/store/modules/user'

  import Auth0Api from '@/services/api/Auth0Api'

  import CookieHelper from '@/helpers/CookieHelper'

  import type { SignupResponse } from '@/services/interfaces/Auth0'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'Signup',
  props: {
    showAdditionalLoginAction: {
      type: Boolean,
      default: false,
    },
  },
  setup(__props) {

  const route = useRoute()

  const { replaceNonAlphanumericChars, isSachkundeCompany } = useCommonMixin()
  const { facebookAvatar, googleAvatar } = useIcons()
  const {
    validator,
    emailErrors,
    passwordErrors,
    signInWithGoogleConnection,
    signInWithFacebookConnection,
    form,
    tokenKey,
  } = useAuthentication()
  const { translateString } = useI18n()

  const errors = ref([] as { message: string; items: string[] | null }[])
  const errorMessage = ref('')
  const submitting = ref(false)

  

  const $v = computed(() => validator.value)

  const signupDirectConnection = () => {
    $v.value.$touch()
    errors.value = []
    if (!$v.value.$invalid) {
      submitting.value = true
      Auth0Api.dbConnectionSignup(form.value.userEmail, form.value.password)
        .then(() => {
          Auth0Api.dbConnectionSignin(form.value.userEmail, form.value.password)
            .then(async (data) => {
              await CookieHelper.setCrossDomainCookie(tokenKey.value, data.access_token)
              if (process.env.APP_ENV === 'production') {
                ;(window as any).top.postMessage({ type: 'redirectAfterSignup', accessToken: data.access_token }, '*')
              }
              const testDomainParams = route.query.testDomain
              if (testDomainParams === 'dev') {
                window.location.href = '/profile-page?testDomain=dev'
              } else {
                await routeToProfilePage()
              }
            })
            .catch(() => {
              submitting.value = false
              errorMessage.value = translateString('onboarding.errors.access_denied') as string
            })
        })
        .catch((err) => {
          submitting.value = false
          if (err.response?.data) {
            let key
            if (err.response.data.message) {
              key = replaceNonAlphanumericChars(err.response.data.message, '')
              handleSignupResponse(err.response.data)
            } else {
              key = replaceNonAlphanumericChars(err.response.data.description, '')
            }
            errorMessage.value = translateString(`onboarding.errors.${key}`) as string
          }
        })
    }
  }

  const handleSignupResponse = (response: SignupResponse) => {
    switch (response.code) {
      case 'invalid_password':
        if (typeof response.description === 'object') {
          errors.value.push(
            ...response.description.rules.map((rule) => {
              return {
                message: formatMessage(rule.message, rule.format),
                items:
                  rule.items?.map((item) => {
                    const key = replaceNonAlphanumericChars(item.message, '')
                    return translateString(`onboarding.errors.${key}`) as string
                  }) || null,
              }
            }),
          )
        }
        return
      default:
        errors.value.push({ message: response.description as string, items: null })
    }
  }

  const formatMessage = (message: string, format: number[]) => {
    format.forEach((f) => {
      message = message.replace('%d', f.toString())
    })
    const key = replaceNonAlphanumericChars(message, '')
    return translateString(`onboarding.errors.${key}`) as string
  }

  const routeToProfilePage = async () => {
    if (isSachkundeCompany.value && route.name === 'CustomRegistration') {
      // this is for the new SKG signup flow
      await UserModule.getUser()
      return
    }

    /*
     check for search params if present
     this could include UTM params that we want to capture
     */
    const urlParams = new URLSearchParams(window.location.search)

    const protocol = window.location.protocol
    const host = window.location.host

    const onboardingUrl = `${protocol}//${host}/profile-page`
    const newUrl = new URL(onboardingUrl)

    newUrl.search = urlParams.toString()
    window.location.href = newUrl.toString()
  }

return { __sfc: true,route, replaceNonAlphanumericChars, isSachkundeCompany, facebookAvatar, googleAvatar, validator, emailErrors, passwordErrors, signInWithGoogleConnection, signInWithFacebookConnection, form, tokenKey, translateString, errors, errorMessage, submitting, $v, signupDirectConnection, handleSignupResponse, formatMessage, routeToProfilePage, computed, ref, KetchUpButton, LoadingSpinner, useRoute, useCommonMixin, useIcons, useAuthentication, useI18n, UserModule, Auth0Api, CookieHelper }
}

})